module.exports = __webpack_public_path__ + "img/new3-img6.e345c69f.jpg";